function initProductIngredientsScience() {
  const swiperEl = document.querySelector(".product-ingredients-science__swiper");
  const swiper = swiperEl
    ? new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        allowTouchMove: false,
        pagination: {
          el: ".product-ingredients-science__pagination",
          clickable: false,
        },
      })
    : null;

  if (swiper) {
    // Slides mirror the product-highlight-stages tabs above; index must match 1:1.
    document.addEventListener("phs:tab-change", (event) => {
      swiper.slideTo(event.detail.index);
    });
  }

  document.querySelectorAll(".product-ingredients-science__accordion").forEach((accordion) => {
    const items = Array.from(accordion.querySelectorAll(".product-ingredients-science__accordion-item"));

    items.forEach((item) => {
      const trigger = item.querySelector(".product-ingredients-science__accordion-trigger");
      trigger.addEventListener("click", () => {
        const isActive = item.classList.contains("product-ingredients-science__accordion-item--active");

        items.forEach((otherItem) => {
          otherItem.classList.remove("product-ingredients-science__accordion-item--active");
          otherItem.querySelector(".product-ingredients-science__accordion-trigger").setAttribute("aria-expanded", "false");
        });

        if (!isActive) {
          item.classList.add("product-ingredients-science__accordion-item--active");
          trigger.setAttribute("aria-expanded", "true");
        }

        if (swiper) {
          setTimeout(() => swiper.updateAutoHeight(300), 320);
        }
      });
    });
  });
}

document.readyState !== "loading"
  ? initProductIngredientsScience()
  : document.addEventListener("DOMContentLoaded", initProductIngredientsScience);
